import React, { useRef, useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import styles from "./landing-page.module.css";
import { WallContentRow } from "./wall-content-row";
import { WallContentGrid } from "./wall-content-grid";
import { TemplateCollection } from "PosterEditor/model/template-collection";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { HeroBannerVariantOne } from "./components/hero-banner-one";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { applyTemplateToProject } from "PosterEditor/model/project-template";
import { usePaths } from "BEDROCK/paths";

export interface LandingPageProps {
  titleCollection: TemplateCollection;
}

export const LandingPageOne = (props: LandingPageProps) => {
  const { loadTemplatesByIDs } = useTemplateStore();
  const { draftProject, projects } = useProjectStore();
  const paths = usePaths();
  const [titleTemplates, setTitleTemplates] = useState<ProjectTemplate[]>([]);

  const load = useCallback(() => {
    loadTemplatesByIDs(props.titleCollection.templateIDs).then(
      setTitleTemplates
    );
  }, [loadTemplatesByIDs, props.titleCollection.templateIDs]);

  useEffect(() => {
    load();
  }, [load]);

  const createProjectWithTemplate = (template: ProjectTemplate) => {
    const project = draftProject(false, template);
    applyTemplateToProject(template, project);

    paths.navigateTo(paths.mapEditor + "/" + project.id);
  };

  return (
    <div
      className={styles.container}
      // style={{ backgroundImage: `url("/backgrounds/wall-background-1.png")` }}
    >
      <HeroBannerVariantOne
        collection={props.titleCollection}
        onClickTemplate={(template) => {
          createProjectWithTemplate(template);
        }}
      />
    </div>
  );
};

const itemVariants = {
  initial: { opacity: 0, y: -40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 300, damping: 50 },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: { duration: 0.7 },
  },
};

interface WallContentProps {
  index: number;
}
const WallContent = (props: WallContentProps) => {
  if (props.index === 0) {
    return <WallContentGrid animationVariants={itemVariants} />;
  }
  if (props.index === 1) {
    return <WallContentRow animationVariants={itemVariants} />;
  } else {
    return <WallContentGrid animationVariants={itemVariants} />;
  }
};
